const main = () => {
    const element = document.querySelector('[name="checkout"]');
    if (!element) {
        return setTimeout(() => {
            main();
        }, 300);
    }

    if (window.roarJs?.Legal) {
        window.roarJs?.Legal.refresh();
    }
};

main();
